import gsap from "gsap";

export default function initHome() {
  const root = document.querySelector(".home__slider");
  const slides = Array.from(root?.querySelectorAll(".slide") || []);
  if (!root || slides.length === 0) return;

  const isMultiple = slides.length > 1;

  const videos = slides.map(s => s.querySelector("video") || null);


  const titleSlides = document.querySelectorAll('.home__bottom .slide');

  // params
  const SPEED = 0.7;
  const EASING = "power2.inOut";

  // init videos
  videos.forEach(v => { if (v) { v.muted = true; v.playsInline = true; } });

  let index = 0;
  let anim = null;

  // Lottie header helper
  function getHeaderLottie() {
    const el = document.querySelector('.header__icon');
    return el && el._lottie ? el._lottie : null;
  }

  function playHeaderSegment(dir) {
    const l = getHeaderLottie();
    if (!l) return;
    try {
      // ensure single run of the segment
      if (typeof l.setLoop === 'function') l.setLoop(false);
      else l.loop = false;

      // Play requested segments in sequence depending on direction
      // next: 0 -> 118, then 158 -> 216
      // prev: 216 -> 79, then 59 -> 0
      const segs = dir > 0
        ? [[0, 59], [158, 216]]
        : [[216, 158], [59, 0]];
      l.playSegments(segs, true);
    } catch { }
  }

  slides.forEach((s, i) => gsap.set(s, {
    xPercent: i === 0 ? 0 : 100,
    zIndex: i === 0 ? 2 : 1
  }));

  titleSlides[index].classList.add('show');

  setTimeout(() => {
    playVideo(0);
  }, 500);


  function resetOtherVideos(active) {
    videos.forEach((v, k) => {
      if (!v || k === active) return;
      try {
        // keep them paused and rewound
        v.pause();
        v.currentTime = 0;
      } catch { }
    });
  }

  function playVideo(i) {
    const v = videos[i];
    if (!v) return;

    // stop others
    videos.forEach((other, k) => {
      if (!other || k === i) return;
      try { other.pause(); } catch { }
      // don't forcibly reset here; let it be
    });

    // ensure correct listeners per video
    v.removeEventListener("ended", onEnded);
    if (isMultiple) {
      v.addEventListener("ended", onEnded);
    }

    const start = () => {
      try { v.currentTime = 0; } catch { }
      v.play().catch(() => { });
    };

    if (isNaN(v.duration) || v.readyState < 1) {
      // wait until metadata is ready before seeking to 0
      const onMeta = () => {
        v.removeEventListener("loadedmetadata", onMeta);
        start();
      };
      v.addEventListener("loadedmetadata", onMeta);
      // nudge loading
      try { v.load(); } catch { }
    } else {
      start();
    }
  }


  function onEnded() {
    next();
  }

  function next() {
    playHeaderSegment(+1);
    goTo((index + 1) % slides.length, +1);
  }

  function prev() {
    playHeaderSegment(-1);
    goTo((index - 1 + slides.length) % slides.length, -1);
  }

  function goTo(target, dir = +1) {
    if (anim) anim.kill();

    const current = slides[index];
    const nextEl = slides[target];

    titleSlides[index].classList.remove('show');

    gsap.set(nextEl, { xPercent: 100 * dir, zIndex: 3 });
    gsap.set(current, { zIndex: 2 });

    anim = gsap.timeline({
      defaults: { duration: SPEED, ease: EASING },
      onComplete: () => {
        gsap.set(current, { xPercent: -100 * dir, zIndex: 1 });
        gsap.set(nextEl, { xPercent: 0, zIndex: 2 });
        index = target;
        titleSlides[index].classList.add('show');
        playVideo(index);

        resetOtherVideos(index);
      }
    });

    anim.to(current, { xPercent: -100 * dir }, 0)
      .to(nextEl, { xPercent: 0 }, 0);
  }

  document.addEventListener("visibilitychange", () => {
    if (document.hidden) videos[index]?.pause();
    else videos[index]?.play().catch(() => { });
  });

  if (isMultiple) {
    document.querySelector(".js-next")?.addEventListener("click", () => next());
    document.querySelector(".js-prev")?.addEventListener("click", () => prev());
  } else {
    // Hide legacy arrows if they exist
    document.querySelectorAll(".home__slider__nav").forEach(n => n.style.display = "none");
  }

  (function edgeGooNav() {
    const left = document.querySelector('.edgeNav.edgeNav--left');
    const right = document.querySelector('.edgeNav.edgeNav--right');
    const dotL = left?.querySelector('.edgeNav__dot');
    const dotR = right?.querySelector('.edgeNav__dot');
    const gooL = left?.querySelector('.edgeNav__goo');
    const gooR = right?.querySelector('.edgeNav__goo');
    if (!left || !right || !dotL || !dotR) return;

    if (!isMultiple) {
      left.style.display = 'none';
      right.style.display = 'none';
      return;
    }

    const EDGE_THRESHOLD = 300; // px from edge to start effect
    const MAX_PULL = 56;        // how far the dot slides into viewport
    const GAP_PX = 40;        // final gap from pillar when fully revealed

    const SCALE_OVR_MIN = 0.28; // overall scale start
    const SCALE_OVR_MAX = 1.00; // overall scale end
    const SCALE_X_MIN = 0.18; // narrow bar start
    const SCALE_X_MAX = 1.00; // full width end
    const SCALE_Y_MIN = 1.15; // taller start
    const SCALE_Y_MAX = 1.00; // equal height end
    const BR_MIN_PCT = 6;    // border-radius start
    const BR_MAX_PCT = 50;   // border-radius end
    const OP_MIN = 0.60; // opacity start
    const OP_MAX = 1.00; // opacity end

    const smoothstep = (t) => t * t * (3 - 2 * t);

    function proximityRight(x) {
      const dist = Math.max(0, window.innerWidth - x);
      const t = 1 - Math.min(1, dist / EDGE_THRESHOLD);
      return smoothstep(t);
    }
    function proximityLeft(x) {
      const dist = Math.max(0, x);
      const t = 1 - Math.min(1, dist / EDGE_THRESHOLD);
      return smoothstep(t);
    }

    function applyMorph(dot, f, side) {
      const sO = SCALE_OVR_MIN + (SCALE_OVR_MAX - SCALE_OVR_MIN) * f;  // overall
      const sX = SCALE_X_MIN + (SCALE_X_MAX - SCALE_X_MIN) * f;  // width
      const sY = SCALE_Y_MIN + (SCALE_Y_MAX - SCALE_Y_MIN) * f;  // height
      const br = BR_MIN_PCT + (BR_MAX_PCT - BR_MIN_PCT) * f;  // border-radius %
      const op = OP_MIN + (OP_MAX - OP_MIN) * f;  // opacity

      const pull = (f * (MAX_PULL + GAP_PX));
      const tx = side === 'right' ? -pull : pull;
      dot.style.transform = `translate(${tx}px, -50%) scale(${(sX * sO).toFixed(3)}, ${(sY * sO).toFixed(3)})`;
      dot.style.borderRadius = `${br}%`;
      dot.style.opacity = op;

    }

    function reset(dot) {
      dot.style.transform = `translate(0, -50%) scale(${(SCALE_X_MIN * SCALE_OVR_MIN)}, ${(SCALE_Y_MIN * SCALE_OVR_MIN)})`;
      dot.style.borderRadius = `${BR_MIN_PCT}%`;
      dot.style.opacity = OP_MIN;
    }

    function onPointerMove(e) {
      const x = e.clientX ?? (e.touches && e.touches[0]?.clientX) ?? 0;

      const nearR = (window.innerWidth - x) <= EDGE_THRESHOLD;
      const nearL = x <= EDGE_THRESHOLD;

      right.classList.toggle('live', nearR);
      left.classList.toggle('live', nearL);

      // Update morphs
      if (nearR) applyMorph(dotR, proximityRight(x), 'right');
      if (nearL) applyMorph(dotL, proximityLeft(x), 'left');
    }

    function onPointerLeave() {
      right.classList.remove('live');
      left.classList.remove('live');
      reset(dotR); reset(dotL);
    }

    // Detect non-hover/coarse pointers (mobile). On these, auto-animate then keep static.
    const noHover = window.matchMedia('(hover: none)').matches || window.matchMedia('(pointer: coarse)').matches;
    if (noHover) {
      // Ensure goo filters are active
      if (gooL) gooL.style.filter = 'url(#relativeSelectGoo)';
      if (gooR) gooR.style.filter = 'url(#relativeSelectGoo)';

      // Make them interactive and visible
      left.classList.add('live');
      right.classList.add('live');

      // Auto-reveal with CSS transitions to a fully visible state
      // Use a small timeout so initial styles apply before transition
      setTimeout(() => {
        applyMorph(dotL, 1, 'left');
        applyMorph(dotR, 1, 'right');
      }, 50);

      // Clicks still control the carousel
      dotR.addEventListener('click', (e) => { e.stopPropagation(); next(); });
      dotL.addEventListener('click', (e) => { e.stopPropagation(); prev(); });

      // Do not bind pointermove/leave; keep position static
      return;
    }

    window.addEventListener('pointermove', onPointerMove, { passive: true });
    window.addEventListener('pointerleave', onPointerLeave, { passive: true });

    // Clicks control the carousel
    dotR.addEventListener('click', (e) => { e.stopPropagation(); next(); });
    dotL.addEventListener('click', (e) => { e.stopPropagation(); prev(); });

    // Keep goo containers visible only when active (opacity via CSS)
    if (gooL) gooL.style.filter = 'url(#relativeSelectGoo)';
    if (gooR) gooR.style.filter = 'url(#relativeSelectGoo)';
  })();


  (function addSwipe() {
    const el = root;
    if (!el) return;

    const isMobile = window.matchMedia("(max-width: 768px)").matches;
    if (!isMobile || !isMultiple) return;

    const SWIPE_MIN = 50;
    const MAX_ANGLE_DEG = 35;
    const MAX_ANGLE_TAN = Math.tan((MAX_ANGLE_DEG * Math.PI) / 180);
    const VELOCITY_MIN = 0.45;

    let startX = 0, startY = 0, lastX = 0, lastT = 0;
    let dragging = false, lockedAxis = null;
    let pointerId = null;

    const onDown = (e) => {
      if (e.touches && e.touches.length > 1) return;

      pointerId = e.pointerId ?? 'touch';
      const p = (e.touches ? e.touches[0] : e);
      startX = lastX = p.clientX;
      startY = p.clientY;
      lastT = performance.now();
      dragging = true;
      lockedAxis = null;

      el.setPointerCapture?.(pointerId);
    };

    const onMove = (e) => {
      if (!dragging) return;
      const p = (e.touches ? e.touches[0] : e);

      const dx = p.clientX - startX;
      const dy = p.clientY - startY;

      if (!lockedAxis) {
        if (Math.abs(dx) > 6 || Math.abs(dy) > 6) {
          const isMostlyX = Math.abs(dy) / Math.abs(dx || 1) < MAX_ANGLE_TAN;
          lockedAxis = isMostlyX ? 'x' : 'y';
        }
      }
      if (lockedAxis === 'x') {
        e.preventDefault();
      }

      lastX = p.clientX;
      lastT = performance.now();
    };

    const onUp = (e) => {
      if (!dragging) return;

      const now = performance.now();
      const dx = lastX - startX;
      const dt = Math.max(now - lastT, 1);
      const vx = Math.abs(dx) / dt;

      const horizontal = lockedAxis === 'x' || (Math.abs(dx) > Math.abs(startY - (e.changedTouches?.[0]?.clientY ?? startY)));

      const busy = anim && anim.isActive && anim.isActive();

      if (!busy && horizontal && (Math.abs(dx) >= SWIPE_MIN || vx >= VELOCITY_MIN)) {
        if (dx < 0) next(); else prev();
      }

      dragging = false;
      lockedAxis = null;

      try { el.releasePointerCapture?.(pointerId); } catch { }
      pointerId = null;
    };

    el.addEventListener('touchstart', onDown, { passive: true });
    el.addEventListener('touchmove', onMove, { passive: false });
    el.addEventListener('touchend', onUp, { passive: true });
    el.addEventListener('pointerdown', onDown, { passive: true });
    el.addEventListener('pointermove', onMove, { passive: false });
    el.addEventListener('pointerup', onUp, { passive: true });
  })();





  // bottom 
  const bottomEl = document.querySelector('.home__bottom');
  if (!bottomEl) return;

  const mm = gsap.matchMedia();

  mm.add({
    isDesktop: "(min-width: 769px)",
    isMobile: "(max-width: 768px)"
  }, (context) => {
    const { isMobile } = context.conditions;
    const finalWidth = isMobile ? "calc(100% - 4.8rem)" : "62.5rem";
    const settleWidth = isMobile ? "calc(100% - 5rem)" : "61rem";

    gsap.set(bottomEl, {
      width: "24rem",
      height: "4.4rem",
      y: 15,
      opacity: 0
    });

    const tl = gsap.timeline({ defaults: { ease: "power2.out" } });

    tl.to(bottomEl, {
      opacity: 1,
      width: finalWidth,
      height: "4.9rem",
      y: 0,
      duration: 0.5
    });

    tl.to(bottomEl, {
      width: settleWidth,
      height: "4.8rem",
      duration: 0.4,
      ease: "power1.out"
    });

    return () => mm.revert();
  });
}
